import React from 'react';

export default (props) => {
  return (
    <button data-tip={props.tooltip} onClick={props.onClick} className={`button ${ props.color + ' ' + props.iconclass }`}/>
  );
}